export default "__VITE_ASSET__DcxzEKQL__"